/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PollNotificationsParams = {
/**
 * ISO 8601 timestamp of last poll
 */
since: string;
/**
 * Max seconds to hold the connection (capped server-side)
 * @minimum 1
 * @maximum 25
 */
timeout?: number;
};
